import LesserEval from 'piivo-poster-engine/src/lib/util/lesserEval';

/**
 * Class to evaluate all properties object
 */
export default class AttributeManager {
  /**
   * Function to apply LesserEval.evaluateExpression() on string
   * @param {String} string - string to evaluate
   * @param {Object} bindings - object with bindings
   * @param {Object} types - object with types
   * @returns {String} evaluated string
   */
  static computeString(string, bindings, types) {
    return LesserEval.expressionEval(string, bindings, types);
  }

  /**
   * Function to compute array items
   * @param {Array} array - array to iterate
   * @param {Object} bindings - object with bindings value
   * @param {Object} types - object with types value
   * @returns {Array} evaluated array
   */
  static computeArray(array, bindings, types) {
    for (let i = 0; i < array.length; i++) {
      if (typeof array[i] === 'object') {
        array[i] = AttributeManager.executeComputeMethod(array[i], bindings, types);
      } else {
        array[i] = AttributeManager.computeString(array[i], bindings, types);
      }
    }
    return array;
  }

  /**
   * Function to compute object properties
   * @param {object} object - object to iterate and evalute his properties
   * @param {Object} bindings - object with bindings value
   * @param {Object} types - object with types value
   * @returns {Object} evaluated object
   */
  static computeObject(object, bindings, types) {
    for (const property in object) {
      if (Object.getOwnPropertyDescriptor(object, property).set) {
        // Ignore the property if it does not have a setter.
        // Example: protected properties like in the native File object
        object[property] = AttributeManager.executeComputeMethod(object[property], bindings, types);
      }
    }
    return object;
  }

  /**
   * Function to compute object properties. This function call evaluate function depending on types property
   * @param {object} item - object to iterate and evalute his properties
   * @param {Object} bindings - object with bindings value
   * @param {Object} types - object with types value
   * @returns {Object} evaluated object
   */
  static executeComputeMethod(item, bindings, types) {
    if (typeof item === 'object' && item !== null) {
      if (Array.isArray(item)) {
        item = AttributeManager.computeArray(item, bindings, types);
      } else {
        item = AttributeManager.computeObject(item, bindings, types);
      }
    } else if (typeof item === 'string') {
      item = AttributeManager.computeString(item, bindings, types);
    }
    // String, number or null return item without compute
    return item;
  }
}
